// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1yH9s","infoBtn":"quickbooks_infoBtn__3n3n0","formBox":"quickbooks_formBox__2uukQ","formFooter":"quickbooks_formFooter__2k-Hp"};